/**
* HC Full Height Image JS
* -----------------------------------------------------------------------------
*
* All the JS for the HC Full Height Image component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'hc-full-height-image',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.hc-full-height-image' ).each( function( key, val ) {
        let image = $( val ).find( 'img.is-desktop-image' )[0];
        const imageMover = $( val ).find( '.image-mover' )[0];
        let mvmtAmt = '-50%';
        if ( $( val ).find( '.device-video' ).length ) {
          image = $( val ).find( '.device-video' )[0];
          mvmtAmt = '-15vw';
          // mvmtAmt = ( $( image ).width() * -0.6 ) + 'px';
          // console.log( mvmtAmt );
        }

        let start = 'top top-=' + ( val.offsetLeft - window.innerWidth/2 ) * ( window.maxWidth / ( window.maxWidth - window.innerWidth ) );
        let end = '+=' + val.offsetWidth * ( window.maxWidth / ( window.maxWidth - window.innerWidth ) );
        if ( window.innerWidth < 1024 ) {
          start = 'top 75%';
          end = 'bottom 75%';
        }

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: val,
            start: () => start,
            end: () => end,
            toggleClass: {targets: val, className: 'active'},
            scrub: 1,
            onEnter: ( x, y, z ) => {
              if ( $( val ).find( '.device-video' ).length ) {
                image.play();
              }
            },
          },
        } );

        if ( $( val ).find( '.device-video' ).length ) {
          $( image ).on( 'ended', function() {
            $( val ).find( '.device-part' ).addClass( 'is-loaded' );
          } );
        }

        if ( window.innerWidth > 1023 ) {
          tl.to( imageMover, {x: mvmtAmt, ease: 'linear'}, 0 );

          if ( $( val ).find( '.device-part' ).length ) {
            tl.to( $( val ).find( '.device-part--arm' )[0], {x: '-15vw', y: '0%', ease: 'linear'}, 0 );
            tl.to( $( val ).find( '.device-part:not(.device-part--arm)' ), {x: mvmtAmt, y: '0%', ease: 'linear'}, 0 );
          }
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'hc-full-height-image', COMPONENT );
} )( app );
